import { Icon } from "~/v2/components/AssetIcon/AssetIcon";

export interface AssetChainCellProps {
  iconKey: string;
  assetLabel: string;
  chainLabel: string;
}

export const AssetChainCell = ({
  iconKey,
  assetLabel,
  chainLabel,
}: AssetChainCellProps) => (
  <div className="flex min-w-0 flex-col items-start justify-center gap-1">
    <div className="flex min-w-0 items-center gap-2">
      <Icon name={iconKey} size="sm" className="shrink-0" />
      <span className="truncate text-gray-700 text-sm">{assetLabel}</span>
    </div>
    <span className="truncate text-gray-500 text-xs">{chainLabel}</span>
  </div>
);
